import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { BLANK_STRING, ButtonListFieldOptions } from 'embed/constants'
import { css } from 'emotion'
import * as React from 'react'
import { DeepReadonly } from 'utility-types'
import { ButtonIcon } from './icon/index'

const styles = require('./styles')

interface Props {
  onChange: (value?: React.ReactText) => void
  options: ButtonListFieldOptions
  value?: DeepReadonly<React.ReactText | React.ReactText[] | boolean>
  name: string
}

const IconButtonList: React.FunctionComponent<Props> = (props) => {
  const { onChange, name, options, value } = props

  const buttonOptions = options.selectOptions?.filter((option) => option.value !== BLANK_STRING) ?? []

  return (
    <div
      className={classnames(
        styles.buttonList,
        css`
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-gap: 10px;
        `,
      )}
    >
      {buttonOptions.map((option) => (
        <ButtonListOption
          checked={value === option.value}
          key={option.value}
          label={option.label}
          name={name}
          onClick={onChange}
          value={option.value}
        />
      ))}
    </div>
  )
}

interface ButtonListOptionProps {
  checked: boolean
  label: string
  name: string
  onClick: (value?: React.ReactText) => void
  value?: React.ReactText
}

export const ButtonListOption: React.FunctionComponent<ButtonListOptionProps> = (props) => {
  const { checked, label, name, onClick, value } = props

  const handleClick = () => {
    onClick(value)
  }

  return (
    <ThemeConsumer>
      {({ borderRadiusSmall, colorBorder, colorPrimary }) => (
        <label
          className={classnames(
            styles.button,
            css`
              border-color: ${checked ? colorPrimary : colorBorder};
              border-radius: ${borderRadiusSmall};
            `,
          )}
        >
          <ButtonIcon value={value} />
          <input className={styles.radio} name={name} type="radio" value={value} onClick={handleClick} />
          <span className={styles.buttonLabel}>{label}</span>
        </label>
      )}
    </ThemeConsumer>
  )
}

export default IconButtonList
